const COHORT_START_DATE_DAYS_OFFSET: number | undefined = -6;

export const adaptCohortDateToLead = (nearestCohortDate: Date) => {
    const adaptedCohortDate = new Date(nearestCohortDate);

    if (COHORT_START_DATE_DAYS_OFFSET)
        adaptedCohortDate.setDate(adaptedCohortDate.getDate() + COHORT_START_DATE_DAYS_OFFSET);

    if (adaptedCohortDate.getTime() < Date.now())
        throw new Error('The calculated nearest cohort start date less than current time.');

    return adaptedCohortDate;
};
